<!-- DOC INFOS -->
<div class="AboutDocument">
    <h1 class="Title">{{ data.title }}</h1>
    <footer>
      <p>{{ data.creator }} - {{ data.publicationDate }}</p> 
    </footer>
    <p class="Teaser">{{ data.teaserSummary }}</p>
</div>
